import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import Home from "./pages/Home";
import Companies from "./pages/Companies";
import Candidates from "./pages/Candidates";
import Industries from "./pages/Industries";
import About from "./pages/About";
import Process from "./pages/Process";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import { InquiryPage, RegisterPage } from "./pages/FormPages";
import { Imprint, Privacy } from "./pages/Legal";
import { ApplicantsEn, RegisterEn } from "./pages/ApplicantsEn";
import { useSeo } from "./lib/useSeo";

let lenis = null;

const SmoothScroll = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); lenis = null; };
  }, []);
  return null;
};

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const NotFound = () => {
  useSeo("Seite nicht gefunden", "Die angeforderte Seite wurde nicht gefunden.", "/404", true);
  return (
    <section className="container-x min-h-[70vh] pt-[150px] pb-24" data-testid="not-found">
      <p className="eyebrow">Fehler 404</p>
      <h1 className="mt-4 text-4xl sm:text-5xl font-extrabold text-[color:var(--navy)]">Diese Seite gibt es nicht.</h1>
      <Link to="/" className="mt-8 inline-flex rounded-full bg-[color:var(--navy)] px-6 py-3 font-semibold text-white" data-testid="not-found-home-link">Zur Startseite</Link>
    </section>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <ScrollTop />
      <Header />
      <main id="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/unternehmen" element={<Companies />} />
          <Route path="/bewerber" element={<Candidates />} />
          <Route path="/branchen" element={<Industries />} />
          <Route path="/ueber-uns" element={<About />} />
          <Route path="/ablauf" element={<Process />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/personal-anfragen" element={<InquiryPage />} />
          <Route path="/bewerber-registrierung" element={<RegisterPage />} />
          <Route path="/en/applicants" element={<ApplicantsEn />} />
          <Route path="/en/register" element={<RegisterEn />} />
          <Route path="/impressum" element={<Imprint />} />
          <Route path="/datenschutz" element={<Privacy />} />
          <Route path="/intern" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
